export enum tenantRealm {
    MERCHANT_UAT= "merchant-uat",
    MERCHANT_DEV = "merchant-dev",
    MERCHANT_PROD = "merchant-prod",
    MERCHANT_QA = "merchant-qa",
    MERCHANT_PERF = "merchant-perf",
    BPLSIZER = "bplsizer"
  }